export default __webpack_public_path__ + "static/media/yellowwallpaper.f2ccf555.jpg";